import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FiSend, FiArrowLeft } from 'react-icons/fi';
import './styles/auth.css';

import CAMPUS_IMG from './assets/kampus_A.png';
import ikona from './assets/icon.png';

export default function ResetHaslaRequest() {
    const [login, setLogin] = useState('');
    const [blad, setBlad] = useState('');
    const [ok, setOk] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBlad('');
        setOk('');
        setLoading(true);

        try {
            const res = await axios.post('/api/uzytkownicy/reset-hasla/request', { login });
            setOk(res.data?.msg || 'Jeśli konto istnieje, wysłaliśmy link do resetu hasła.');
        } catch (err) {
            // tu i tak najlepiej pokazać generycznie
            setOk('Jeśli konto istnieje, wysłaliśmy link do resetu hasła.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="auth-hero-bg"
            style={{ backgroundImage: `url("${CAMPUS_IMG}")` }}
            role="img"
            aria-label="Zdjęcie kampusu uczelni w tle"
        >
            <div className="auth-glass">
                <div className="auth-head">
                    <div className="auth-badge" aria-hidden>
                        <img src={ikona} alt="Logo" style={{ height: '80px', width: '64px' }} />
                    </div>
                    <div>
                        <h1 className="auth-title">Reset hasła</h1>
                    </div>
                </div>

                <div className="auth-msg">
                    {!!ok && <div className="auth-ok">{ok}</div>}
                    {!!blad && <div className="auth-err">{blad}</div>}
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="auth-field">
                        <label htmlFor="login" className="auth-label">Numer indeksu / adres e-mail</label>
                        <div className="auth-input-wrap">
                            <input
                                id="login"
                                className="auth-input"
                                type="text"
                                placeholder="Wpisz numer indeksu lub e-mail"
                                value={login}
                                onChange={(e) => setLogin(e.target.value)}
                                autoComplete="username"
                                required
                            />
                        </div>
                    </div>

                    <button type="submit" className="auth-cta" disabled={loading}>
                        <FiSend size={18} />
                        {loading ? 'Wysyłam...' : 'Wyślij link resetu'}
                    </button>
                </form>

                <div className="auth-foot">
                    <button className="auth-link" onClick={() => navigate('/')} style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
                        <FiArrowLeft /> Wróć do logowania
                    </button>
                </div>
            </div>

            <div className="auth-legal">
                © {new Date().getFullYear()} Gdańska Akademia Medyczna Nauk Stosowanych
            </div>
        </div>
    );
}
